import { render, staticRenderFns } from "./ConfigVersionSwitchV1.vue?vue&type=template&id=1a8a947f&"
import script from "./ConfigVersionSwitchV1.vue?vue&type=script&lang=ts&"
export * from "./ConfigVersionSwitchV1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports